// 🌍 Liste statique de tous les pays avec codes ISO et indicatifs téléphoniques
// Utilisée comme fallback si l'API externe ne répond pas
const COUNTRIES = [
  { code: "AF", name: "Afghanistan", phoneCode: "93" },
  { code: "AL", name: "Albanie", phoneCode: "355" },
  { code: "DZ", name: "Algérie", phoneCode: "213" },
  { code: "AD", name: "Andorre", phoneCode: "376" },
  { code: "AO", name: "Angola", phoneCode: "244" },
  { code: "AG", name: "Antigua-et-Barbuda", phoneCode: "1268" },
  { code: "AR", name: "Argentine", phoneCode: "54" },
  { code: "AM", name: "Arménie", phoneCode: "374" },
  { code: "AU", name: "Australie", phoneCode: "61" },
  { code: "AT", name: "Autriche", phoneCode: "43" },
  { code: "AZ", name: "Azerbaïdjan", phoneCode: "994" },
  { code: "BS", name: "Bahamas", phoneCode: "1242" },
  { code: "BH", name: "Bahreïn", phoneCode: "973" },
  { code: "BD", name: "Bangladesh", phoneCode: "880" },
  { code: "BB", name: "Barbade", phoneCode: "1246" },
  { code: "BE", name: "Belgique", phoneCode: "32" },
  { code: "BZ", name: "Belize", phoneCode: "501" },
  { code: "BJ", name: "Bénin", phoneCode: "229" },
  { code: "BT", name: "Bhoutan", phoneCode: "975" },
  { code: "BY", name: "Biélorussie", phoneCode: "375" },
  { code: "MM", name: "Birmanie", phoneCode: "95" },
  { code: "BO", name: "Bolivie", phoneCode: "591" },
  { code: "BA", name: "Bosnie-Herzégovine", phoneCode: "387" },
  { code: "BW", name: "Botswana", phoneCode: "267" },
  { code: "BR", name: "Brésil", phoneCode: "55" },
  { code: "BN", name: "Brunei", phoneCode: "673" },
  { code: "BG", name: "Bulgarie", phoneCode: "359" },
  { code: "BF", name: "Burkina Faso", phoneCode: "226" },
  { code: "BI", name: "Burundi", phoneCode: "257" },
  { code: "KH", name: "Cambodge", phoneCode: "855" },
  { code: "CM", name: "Cameroun", phoneCode: "237" },
  { code: "CA", name: "Canada", phoneCode: "1" },
  { code: "CV", name: "Cap-Vert", phoneCode: "238" },
  { code: "CF", name: "République centrafricaine", phoneCode: "236" },
  { code: "CL", name: "Chili", phoneCode: "56" },
  { code: "CN", name: "Chine", phoneCode: "86" },
  { code: "CY", name: "Chypre", phoneCode: "357" },
  { code: "CO", name: "Colombie", phoneCode: "57" },
  { code: "KM", name: "Comores", phoneCode: "269" },
  { code: "CG", name: "Congo", phoneCode: "242" },
  { code: "CD", name: "République démocratique du Congo", phoneCode: "243" },
  { code: "KR", name: "Corée du Sud", phoneCode: "82" },
  { code: "CR", name: "Costa Rica", phoneCode: "506" },
  { code: "CI", name: "Côte d'Ivoire", phoneCode: "225" },
  { code: "HR", name: "Croatie", phoneCode: "385" },
  { code: "CU", name: "Cuba", phoneCode: "53" },
  { code: "DK", name: "Danemark", phoneCode: "45" },
  { code: "DJ", name: "Djibouti", phoneCode: "253" },
  { code: "DO", name: "République dominicaine", phoneCode: "1809" },
  { code: "EG", name: "Égypte", phoneCode: "20" },
  { code: "AE", name: "Émirats arabes unis", phoneCode: "971" },
  { code: "EC", name: "Équateur", phoneCode: "593" },
  { code: "ER", name: "Érythrée", phoneCode: "291" },
  { code: "ES", name: "Espagne", phoneCode: "34" },
  { code: "EE", name: "Estonie", phoneCode: "372" },
  { code: "US", name: "États-Unis", phoneCode: "1" },
  { code: "ET", name: "Éthiopie", phoneCode: "251" },
  { code: "FJ", name: "Fidji", phoneCode: "679" },
  { code: "FI", name: "Finlande", phoneCode: "358" },
  { code: "FR", name: "France", phoneCode: "33" },
  { code: "GA", name: "Gabon", phoneCode: "241" },
  { code: "GM", name: "Gambie", phoneCode: "220" },
  { code: "GE", name: "Géorgie", phoneCode: "995" },
  { code: "DE", name: "Allemagne", phoneCode: "49" },
  { code: "GH", name: "Ghana", phoneCode: "233" },
  { code: "GR", name: "Grèce", phoneCode: "30" },
  { code: "GT", name: "Guatemala", phoneCode: "502" },
  { code: "GN", name: "Guinée", phoneCode: "224" },
  { code: "GQ", name: "Guinée équatoriale", phoneCode: "240" },
  { code: "GW", name: "Guinée-Bissau", phoneCode: "245" },
  { code: "HT", name: "Haïti", phoneCode: "509" },
  { code: "HN", name: "Honduras", phoneCode: "504" },
  { code: "HU", name: "Hongrie", phoneCode: "36" },
  { code: "IN", name: "Inde", phoneCode: "91" },
  { code: "ID", name: "Indonésie", phoneCode: "62" },
  { code: "IR", name: "Iran", phoneCode: "98" },
  { code: "IQ", name: "Irak", phoneCode: "964" },
  { code: "IE", name: "Irlande", phoneCode: "353" },
  { code: "IS", name: "Islande", phoneCode: "354" },
  { code: "IL", name: "Israël", phoneCode: "972" },
  { code: "IT", name: "Italie", phoneCode: "39" },
  { code: "JM", name: "Jamaïque", phoneCode: "1876" },
  { code: "JP", name: "Japon", phoneCode: "81" },
  { code: "JO", name: "Jordanie", phoneCode: "962" },
  { code: "KZ", name: "Kazakhstan", phoneCode: "7" },
  { code: "KE", name: "Kenya", phoneCode: "254" },
  { code: "KW", name: "Koweït", phoneCode: "965" },
  { code: "KG", name: "Kirghizistan", phoneCode: "996" },
  { code: "LA", name: "Laos", phoneCode: "856" },
  { code: "LS", name: "Lesotho", phoneCode: "266" },
  { code: "LV", name: "Lettonie", phoneCode: "371" },
  { code: "LB", name: "Liban", phoneCode: "961" },
  { code: "LR", name: "Libéria", phoneCode: "231" },
  { code: "LY", name: "Libye", phoneCode: "218" },
  { code: "LI", name: "Liechtenstein", phoneCode: "423" },
  { code: "LT", name: "Lituanie", phoneCode: "370" },
  { code: "LU", name: "Luxembourg", phoneCode: "352" },
  { code: "MK", name: "Macédoine du Nord", phoneCode: "389" },
  { code: "MG", name: "Madagascar", phoneCode: "261" },
  { code: "MY", name: "Malaisie", phoneCode: "60" },
  { code: "MW", name: "Malawi", phoneCode: "265" },
  { code: "MV", name: "Maldives", phoneCode: "960" },
  { code: "ML", name: "Mali", phoneCode: "223" },
  { code: "MT", name: "Malte", phoneCode: "356" },
  { code: "MA", name: "Maroc", phoneCode: "212" },
  { code: "MU", name: "Maurice", phoneCode: "230" },
  { code: "MR", name: "Mauritanie", phoneCode: "222" },
  { code: "MX", name: "Mexique", phoneCode: "52" },
  { code: "MD", name: "Moldavie", phoneCode: "373" },
  { code: "MC", name: "Monaco", phoneCode: "377" },
  { code: "MN", name: "Mongolie", phoneCode: "976" },
  { code: "ME", name: "Monténégro", phoneCode: "382" },
  { code: "MZ", name: "Mozambique", phoneCode: "258" },
  { code: "NA", name: "Namibie", phoneCode: "264" },
  { code: "NP", name: "Népal", phoneCode: "977" },
  { code: "NI", name: "Nicaragua", phoneCode: "505" },
  { code: "NE", name: "Niger", phoneCode: "227" },
  { code: "NG", name: "Nigeria", phoneCode: "234" },
  { code: "NO", name: "Norvège", phoneCode: "47" },
  { code: "NZ", name: "Nouvelle-Zélande", phoneCode: "64" },
  { code: "OM", name: "Oman", phoneCode: "968" },
  { code: "UG", name: "Ouganda", phoneCode: "256" },
  { code: "UZ", name: "Ouzbékistan", phoneCode: "998" },
  { code: "PK", name: "Pakistan", phoneCode: "92" },
  { code: "PA", name: "Panama", phoneCode: "507" },
  { code: "PG", name: "Papouasie-Nouvelle-Guinée", phoneCode: "675" },
  { code: "PY", name: "Paraguay", phoneCode: "595" },
  { code: "NL", name: "Pays-Bas", phoneCode: "31" },
  { code: "PE", name: "Pérou", phoneCode: "51" },
  { code: "PH", name: "Philippines", phoneCode: "63" },
  { code: "PL", name: "Pologne", phoneCode: "48" },
  { code: "PT", name: "Portugal", phoneCode: "351" },
  { code: "QA", name: "Qatar", phoneCode: "974" },
  { code: "RO", name: "Roumanie", phoneCode: "40" },
  { code: "GB", name: "Royaume-Uni", phoneCode: "44" },
  { code: "RU", name: "Russie", phoneCode: "7" },
  { code: "RW", name: "Rwanda", phoneCode: "250" },
  { code: "SN", name: "Sénégal", phoneCode: "221" },
  { code: "RS", name: "Serbie", phoneCode: "381" },
  { code: "SC", name: "Seychelles", phoneCode: "248" },
  { code: "SL", name: "Sierra Leone", phoneCode: "232" },
  { code: "SG", name: "Singapour", phoneCode: "65" },
  { code: "SK", name: "Slovaquie", phoneCode: "421" },
  { code: "SI", name: "Slovénie", phoneCode: "386" },
  { code: "SO", name: "Somalie", phoneCode: "252" },
  { code: "SD", name: "Soudan", phoneCode: "249" },
  { code: "SS", name: "Soudan du Sud", phoneCode: "211" },
  { code: "LK", name: "Sri Lanka", phoneCode: "94" },
  { code: "SE", name: "Suède", phoneCode: "46" },
  { code: "CH", name: "Suisse", phoneCode: "41" },
  { code: "SR", name: "Suriname", phoneCode: "597" },
  { code: "SY", name: "Syrie", phoneCode: "963" },
  { code: "TJ", name: "Tadjikistan", phoneCode: "992" },
  { code: "TZ", name: "Tanzanie", phoneCode: "255" },
  { code: "TD", name: "Tchad", phoneCode: "235" },
  { code: "CZ", name: "Tchéquie", phoneCode: "420" },
  { code: "TH", name: "Thaïlande", phoneCode: "66" },
  { code: "TG", name: "Togo", phoneCode: "228" },
  { code: "TT", name: "Trinité-et-Tobago", phoneCode: "1868" },
  { code: "TN", name: "Tunisie", phoneCode: "216" },
  { code: "TM", name: "Turkménistan", phoneCode: "993" },
  { code: "TR", name: "Turquie", phoneCode: "90" },
  { code: "UA", name: "Ukraine", phoneCode: "380" },
  { code: "UY", name: "Uruguay", phoneCode: "598" },
  { code: "VA", name: "Vatican", phoneCode: "379" },
  { code: "VE", name: "Venezuela", phoneCode: "58" },
  { code: "VN", name: "Viêt Nam", phoneCode: "84" },
  { code: "YE", name: "Yémen", phoneCode: "967" },
  { code: "ZM", name: "Zambie", phoneCode: "260" },
  { code: "ZW", name: "Zimbabwe", phoneCode: "263" },
];

export default COUNTRIES;